import { render, staticRenderFns } from "./AppFieldTags.vue?vue&type=template&id=baa074ca&scoped=true&"
import script from "./AppFieldTags.vue?vue&type=script&lang=js&"
export * from "./AppFieldTags.vue?vue&type=script&lang=js&"
import style0 from "./AppFieldTags.vue?vue&type=style&index=0&id=baa074ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa074ca",
  null
  
)

export default component.exports